import { z } from "zod";
import { InviteStatus, OptInStatus } from "./enums";
export const RegisterSuccessSchema = z.object({});
export const RedeemedCodeSchema = z.object({
    redeemedAt: z.string(),
});
export const BetaKeyDetailsSchema = z.object({
    code: z.string(),
    platform: z.string(),
});
export const UserStatusSummarySchema = z.object({
    optInStatus: z.nativeEnum(OptInStatus).optional(),
    inviteCode: z.string().optional(),
    inviteStatus: z.nativeEnum(InviteStatus).optional(),
    keys: z.array(BetaKeyDetailsSchema).optional(),
});
//# sourceMappingURL=responses.js.map